import { useContext } from 'react';
// @ts-ignore
import { LocalizeContext, LocalizeContextProps } from 'react-localize-redux';

export default function useTranslate(): LocalizeContextProps {
    return useContext(LocalizeContext);
}
